import { FormFieldProps } from "@/types/FormFieldsType";
import { FieldValues, Path } from "react-hook-form";
import { Fragment, useState } from "react";
import { EyeOff, Eye } from "lucide-react";

export interface FieldProps<T extends FieldValues> extends FormFieldProps<T> {
  inputStyle?: string;
  required: boolean;
  label: string;
  labelStyle?: string;
  inputContainerStyle?: string;
}

const FormField = <T extends FieldValues>({
  type,
  placeholder,
  name,
  register,
  error,
  valueAsNumber = false,
  inputStyle = "",
  label,
  labelStyle,
  required = false,
  inputContainerStyle = "flex justify-center flex-col w-full"
}: FieldProps<T>) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  return (
    <Fragment>
      <label htmlFor={name} className={labelStyle ? labelStyle : "block text-sm font-medium text-gray-700 dark:text-gray-300"}>
        {label} {required ? '*' : ''}
      </label>
      <div className={`${inputContainerStyle} relative`}>
        <input
          className={`${inputStyle} ${isPassword ? "pr-10" : ""}`}
          type={isPassword ? (showPassword ? "text" : "password") : type}
          required={required}
          placeholder={placeholder}
          {...register(name as Path<T>, { valueAsNumber })}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            {showPassword ? (
              // eye-slash icon
              <EyeOff size={20} />
            ) : (
              // eye icon
              <Eye size={20} />
            )}
          </button>
        )}

        {error && <span className="error-message mt-1 text-red-400">{error.message}</span>}
      </div>
    </Fragment>
  );
};

export default FormField;
